import React from "react"
import { Cell } from "fixed-data-table-2"
import moment from "moment"
import sheetConstants from "sheets/constants"

/**
 * 
 * Renders a year cell, content is either undefined or an integer in order to perform min/max filtering
 */
const YearCell = ({ rowId, columnId, children, sheetId, columnIndex, editing, ...props }) =>
    <Cell {...props}>{children ? Number(moment(children).local().format('YYYY')) : undefined}</Cell>

export default YearCell
